import { Controller } from "@hotwired/stimulus";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";

// Initialize Firebase (Replace with your actual config)
const firebaseConfig = {
  apiKey: "AIzaSyCpTo1XwaPgh4ubES5DfRVfngoZUgpidWg",
  authDomain: "mapmydeal-dealapp.firebaseapp.com",
  projectId: "mapmydeal-dealapp",
  storageBucket: "mapmydeal-dealapp.firebasestorage.app",
  messagingSenderId: "587969660436",
  appId: "1:587969660436:web:aa49a7d60c4711f0ce0901",
  measurementId: "G-16EF1BV0SS",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
auth.useDeviceLanguage();

// Connects to data-controller="firebase"
export default class extends Controller {
  static targets = ["phoneInput", "otpInput", "step1", "step2", "message"];

  connect() {
    this.setupRecaptcha();
  }

  setupRecaptcha() {
    // 'sign-in-button' is the ID of your Send Code button
    // We use invisible reCAPTCHA for better UX
    window.recaptchaVerifier = new RecaptchaVerifier(auth, "sign-in-button", {
      size: "invisible",
      callback: (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        this.sendCode();
      },
    });
  }

  async sendCode(event) {
    if (event) event.preventDefault();

    const phoneNumber = this.phoneInputTarget.value;
    const appVerifier = window.recaptchaVerifier;

    try {
      this.showMessage("Sending code...", "text-blue-500");

      // Send the SMS
      this.confirmationResult = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        appVerifier,
      );

      // Setup UI for Step 2
      this.step1Target.classList.add("hidden");
      this.step2Target.classList.remove("hidden");
      this.showMessage("Code sent!", "text-green-500");
    } catch (error) {
      console.error("SMS Error:", error);
      this.showMessage(`Error: ${error.message}`, "text-red-500");

      // Reset reCAPTCHA so user can try again
      window.recaptchaVerifier.render().then((widgetId) => {
        grecaptcha.reset(widgetId);
      });
    }
  }

  async verifyCode(event) {
    event.preventDefault();
    const code = this.otpInputTarget.value;

    try {
      this.showMessage("Verifying...", "text-blue-500");

      // 1. Verify code with Firebase Client SDK
      const result = await this.confirmationResult.confirm(code);
      const user = result.user;

      // 2. Get the ID Token (JWT) securely
      const idToken = await user.getIdToken();

      // 3. Send ID Token to Rails Backend
      this.createRailsSession(idToken);
    } catch (error) {
      console.error("Verification Error:", error);
      this.showMessage("Invalid code", "text-red-500");
    }
  }

  async createRailsSession(idToken) {
    const csrfToken = document.querySelector("[name='csrf-token']").content;

    const response = await fetch("/user_sessions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 2. THIS HEADER IS CRITICAL
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ token: idToken }),
    });

    if (response.ok) {
      window.location.href = "/"; // Redirect on success
    } else {
      this.showMessage("Server verification failed", "text-red-500");
      console.log(response);
    }
  }

  showMessage(msg, colorClass) {
    this.messageTarget.textContent = msg;
    this.messageTarget.className = colorClass;
  }
}
